import React, { useContext, useCallback } from 'react';

import { SettingsIcon } from '@vlabs/icons';
import {
  Page, PageContent, PageHeader, usePageContext,
} from '@vlabs/monokit/shared/ui/page';
import { Divider, Tabs, Tab } from '@vlabs/uikit';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button/IconButton';
import { useTranslation } from 'react-i18next';

import { AddButtonWithDropdown } from './add-button-with-dropdown/AddButtonWithDropdown';
import { QueueContext, QueueContextProvider } from './queue-context/QueueContext';
import { QueueEventsContextProvider } from './queue-context/QueueEventsContext';
import st from './QueuePage.module.sass';
import { MonitoringTab, StatisticTab } from './tabs';

function QueuePage() {
  const { getTitleComponent } = usePageContext();
  const {
    setIsSettingsModalOpen,
    activeTab,
    setActiveTab,
    setStreamIdsForStatistic,
  } = useContext(QueueContext);

  const { t } = useTranslation();

  const actions = (
    <div className={st.Actions}>
      <AddButtonWithDropdown />
      <IconButton
        data-testid="OpenPageSettingsButton"
        icon={<SettingsIcon />}
        kind="secondary"
        onClick={() => setIsSettingsModalOpen(true)}
        shape="square"
        variant="outlined"
      />
    </div>
  );

  const handleTabActivation = useCallback((tab) => {
    if (tab === activeTab) return;
    // при переключении таба сбрасываем выбранные для статистики очереди
    setStreamIdsForStatistic((prev) => (prev.length ? [] : prev));
    setActiveTab(tab);
  }, [activeTab]);

  const tabs = (
    <Tabs
      activeTabIndex={activeTab === 'monitoring' ? 0 : 1}
      onTabActivation={handleTabActivation}
    >
      <Tab
        header={t('queue:tabs.monitoring tab.header')}
        name="monitoring"
      />
      <Tab
        header={t('queue:tabs.statistic tab.header')}
        name="statistic"
      />
    </Tabs>
  );

  return (
    <Page className={activeTab === 'statistic' ? st.QueuePage : ''}>
      <PageContent>
        <PageHeader
          actions={activeTab === 'monitoring' && actions}
          title={(
            <React.Fragment>
              {getTitleComponent(t('queue:queue page.title'))}
              {tabs}
            </React.Fragment>
          )}
        />
        {activeTab === 'monitoring' && <QueueEventsContextProvider><MonitoringTab /></QueueEventsContextProvider>}
        {activeTab === 'statistic' && <StatisticTab />}
      </PageContent>
    </Page>
  );
}

function QueuePageWithContext() {
  return <QueueContextProvider><QueuePage /></QueueContextProvider>;
}

export { QueuePageWithContext as QueuePage };
